module.exports = __webpack_public_path__ + "img/img_kiwoom_design3_m.63541b4a.png";